import { ChangeDetectionStrategy, Component, computed, inject, Input } from '@angular/core';
import { DecisionNode } from '../../../core/models/decision-tree.model';
import { AnfrageWizardStore } from '../store/anfrage-wizard.store';
import { NodeRendererInputs } from './node-renderer';

/**
 * Tile-based single_select renderer. Two density modes are supported via the
 * option count heuristic: ≤4 options → spacious tiles with optional helper
 * count, >4 → compact list. Visual style follows the design's StepBereich
 * tile: dark green active state, stone surface idle.
 */
@Component({
  selector: 'app-single-select-renderer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './single-select-renderer.component.html',
  styleUrl: './single-select-renderer.component.scss',
})
export class SingleSelectRendererComponent implements NodeRendererInputs {
  private readonly store = inject(AnfrageWizardStore);

  @Input({ required: true }) node!: DecisionNode;
  @Input({ required: true }) nodeKey!: string;

  readonly currentValue = computed(() => this.store.answers()[this.node?.id]);

  /** Option-glyph: monogram from the option label, mirrors the design's TileGlyph. */
  glyphFor(label: string): string {
    return label
      .split(/[\s\-/]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0] ?? '')
      .join('')
      .toUpperCase();
  }

  pick(value: string): void {
    this.store.select(this.nodeKey, value);
  }
}
